var map = {
	"./landing/header_one.jpg": 641,
	"./landing/header_one_mobile.jpg": 144,
	"./landing/shattered.png": 779,
	"./logo-unimed.png": 545,
	"./patterns/header-profile.png": 724,
	"./patterns/shattered.png": 747,
	"./uni.jpg": 381,
	"./user.png": 422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;